export default __webpack_public_path__ + "static/media/userSharePass.9fd2a30a.svg";